import { useEffect } from "react";
import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import BestQuotes from "./components/BestQuotes";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import NewForm from "./components/NewForm";
import Pricing from "./components/Pricing";
import Slider from "./components/Slider";

import StripSection from "./components/StripSection";
import LocationBenefits from "./components/LocationBenefits";

function App() {
  const project = "Godrej Horizon";
  const galleryImages = [
    {
      src: "images/gallery1.jpg",
      alt: "gallery1",
      title: "gallery1",
    },
    {
      src: "images/gallery2.jpg",
      alt: "gallery2",
      title: "gallery2",
    },
    {
      src: "images/gallery3.jpg",
      alt: "gallery3",
      title: "gallery3",
    },
    {
      src: "images/gallery4.jpg",
      alt: "gallery4",
      title: "gallery4",
    },
    {
      src: "images/gallery5.jpg",
      alt: "gallery5",
      title: "gallery5",
    },
    {
      src: "images/gallery6.jpg",
      alt: "gallery6",
      title: "gallery6",
    },
    {
      src: "images/gallery7.webp",
      alt: "gallery7",
      title: "gallery7",
    },
    // Add more amenities as needed
  ];
  const amenityImages = [
    {
      src: "images/2 Squash Courts.webp",
      alt: "2 Squash Courts",
      title: "2 Squash Courts",
    },
    {
      src: "images/Banquet Hall.webp",
      alt: "Banquet Hall",
      title: "Banquet Hall",
    },
    {
      src: "images/Fully Equipped Gymnasium.webp",
      alt: "Fully Equipped Gymnasium",
      title: "Fully Equipped Gymnasium",
    },
    {
      src: "images/Crèche.webp",
      alt: "Creche",
      title: "Creche",
    },
    {
      src: "images/SWIMMING POOL.webp",
      alt: "SWIMMING POOL",
      title: "SWIMMING POOL",
    },
    // {
    //   src: "images/yoga.jpg",
    //   alt: "yoga",
    //   title: "yoga",
    // }
    // Add more amenities as needed
  ];

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();

    // Disable F12 and Ctrl+Shift+I
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey &&
          e.shiftKey &&
          (e.key.toLowerCase() === "i" || e.key.toLowerCase() === "c"))
      ) {
        e.preventDefault();
      }
    };

    // Attach event listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listeners
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return (
    <>
      <div className="App">
        <Header />
        <Hero />
        <NewForm />
        <StripSection />
        <Details project={project} />
        <Pricing project={project} />
        <FloorPlan project={project} />
        <Slider project={project} title="Amenities" images={amenityImages} />
        <Slider project={project} title="Gallery" images={galleryImages} />
        <LocationBenefits project={project} />
        <AboutDeveloper project={project} />
        <AboutCapitalAcres />
        <BestQuotes />
        <Footer />
        <Form />
      </div>
    </>
  );
}

export default App;
